// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'function';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m14.976 6.912-4.752 4.752m0-4.752 4.752 4.752M11.448 1.296c-.288-.144-.504-.216-.792-.216-1.944 0-2.448 1.944-3.024 4.248C5.544 13.32 7.2 7.344 5.544 13.32c-.576 2.016-1.152 3.744-2.952 3.744-.288 0-.576-.072-.792-.216'
  />
);

export const viewBox = '0 0 18 18';
